import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { AllColecciones } from 'app/models/all-colecciones.model';
import { FichasRegistroBienesCulturales } from 'app/models/fichaRegistro.model';
import { TipologiasInterface } from 'app/models/tipologias.model';
import { BehaviorSubject } from 'rxjs';
import { BienesFilterParams } from './filtro/models/bienes-filter-params';
import { UtilsService } from 'app/modules/utils-service';

@Injectable({providedIn: 'root'})
export class BienesCulturalesService {
    listBienesCulturales:BehaviorSubject<FichasRegistroBienesCulturales>= new BehaviorSubject<FichasRegistroBienesCulturales>(null)
    //
    listaBienesCulturalesFilterParams: BehaviorSubject<BienesFilterParams> = new BehaviorSubject(null)

    constructor(private apiService:ApiService, private utilsService: UtilsService) { }

    get listBienesCulturales$(){
        return this.listBienesCulturales.asObservable()
    }

    set bienesCulturealesFilterParmas(value: any) {
        this.listaBienesCulturalesFilterParams.next(value);
    }

    get bienesCulturealesFilterParmasValue() {
        return this.listaBienesCulturalesFilterParams.getValue()
    }

    getFichaRegistro(params: any) {
        const url = `/bien_cultural`;
        return new Promise((resolve, reject) => {
            this.apiService.GetMethod(url, params, 'Error al obtener listado de Bienes Culturales.')
                .subscribe(async (response: FichasRegistroBienesCulturales) => {
                    this.listBienesCulturales.next(response);
                    resolve(true);
                });
        });
    }


    getTipologias(tipologia_id:number){
        const url= `/tipologias/${tipologia_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error obtener tipología.')
                .subscribe((response:TipologiasInterface) => {
                    resolve(response[0].tipologias)  
                }, error => {
                    reject(error)
                })
        })
    }

    getAllColecciones(){
        const url= `/tipologias/colecciones` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error obtener tipología.')
                .subscribe((response:AllColecciones[]) => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

}